import React from "react";
import {Image, Link} from "@chakra-ui/react";

export const Logo = () => (
    <Link href="/"><Image src="images/logo2.png" alt="logo" width={'120px'} minW={'120px'}/></Link>
)
